module.exports = __webpack_public_path__ + "static/card-img-10-cafa9a118cd50c8298d0429d8fb21cd5.jpg";